<template>
  <div>
    <div class="main-content" style="margin-top: 5px">
      <el-form :disabled="!isEdit" inline label-width="0">
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.DateOfDeparture')">{{ getItemTitle('ETD') }}</span>
          </div>
          <el-date-picker
            v-model="cargoDoc.etd"
            type="date"
            style="width:200px"
            format="yyyy-MM-dd"
            :class="isDifferent('etd')"
          />
        </el-form-item>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.AMSNumber')">{{ getItemTitle('AMS NO') }}</span>
          </div>
          <el-input v-model="cargoDoc.hblNbr2" style="width:200px" :class="isDifferent('hblNbr2')" />
        </el-form-item>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span style="color: #0000FF;" title="MBL号码">{{ getItemTitle('MB/L NO') }}</span>
          </div>
          <el-input v-model="cargoDoc.mbl" style="width:200px" :class="isDifferent('mbl')" />
        </el-form-item>
        <br>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.ArrivalDate')">{{ getItemTitle('ETA') }}</span>
          </div>
          <el-date-picker v-model="cargoDoc.eta" type="date" value-format="yyyy-MM-dd" style="width:200px" :class="isDifferent('eta')" />
        </el-form-item>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.ShippingType')">{{ getItemTitle('Shipment Type') }}</span>
          </div>
          <el-select v-model="cargoDoc.shipmentTypeCode" :disabled="!isEdit" style="width:200px" :class="isDifferent('shipmentTypeCode')">
            <el-option
              v-for="item in ShipmentTypeCode"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.BillOfLadingType')">{{ getItemTitle('B/L Type') }}</span>
          </div>
          <el-select v-model="cargoDoc.amsBlType" no="13" :disabled="!isEdit" style="width:200px" :class="isDifferent('amsBlType')">
            <el-option
              v-for="item in AmsBLType"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <br>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.HtsCode')">{{ getItemTitle('Hts Code') }}</span>
          </div>
          <el-input v-model="cargoDoc.hsCode" style="width:200px" :class="isDifferent('hsCode')" />
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="height: 540px">
      <span class="title" :title="$t('SeaExport.CustomerShippingInformation')">{{ getItemTitle('Customer Delivery Info') }}</span>
      <div class="tabs-container">
        <el-tabs
          v-model="activeTabName"
          type="card"
          style="width: 100%;"
        >
          <el-tab-pane name="tabSellingParty" :label="getItemTitle('Seller')" :title="$t('RailwayExport.BoxOwner2')">
            <tab-customer ref="tabSellingParty" party-type="SE" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :party-name-list="partyNameList" />
          </el-tab-pane>
          <el-tab-pane name="tabBuyingParty" :label="getItemTitle('Buyer')" :title="$t('SeaExport.Buyer')">
            <tab-customer ref="tabBuyingParty" party-type="BY" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :party-name-list="partyNameList" />
          </el-tab-pane>
          <el-tab-pane name="tabManufacturer" :label="getItemTitle('Manufacturer')" :title="$t('Message.Manufacturer')">
            <tab-customer ref="tabManufacturer" party-type="MF" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :is-show="true" :party-name-list="partyNameList" />
          </el-tab-pane>
          <el-tab-pane name="tabConsolidator" :label="getItemTitle('Container Stuffing Location')" :title="$t('SeaExport.Consolidator')">
            <tab-customer ref="tabConsolidator" party-type="CS" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :party-name-list="partyNameList" />
          </el-tab-pane>
          <el-tab-pane name="tabBookingParty" :label="getItemTitle('Consolidator')" :title="$t('SeaExport.OriginalBookingParty')">
            <tab-customer ref="tabBookingParty" party-type="BKP" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :party-name-list="partyNameList" />
          </el-tab-pane>
          <el-tab-pane name="tabConsignee" :label="getItemTitle('Consignee')" :title="$t('SeaExport.Consignee')">
            <tab-customer ref="tabConsignee" party-type="CN" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :party-name-list="partyNameList" />
          </el-tab-pane>
          <el-tab-pane name="tabShipToParty" :label="getItemTitle('Container Ship to')" :title="$t('SeaExport.CargoReceiver')">
            <tab-customer ref="tabShipToParty" party-type="ST" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :party-name-list="partyNameList" />
          </el-tab-pane>
          <el-tab-pane name="tabScheduledContainerStuffing" :label="getItemTitle('Packing Point')" :title="$t('SeaExport.PackingPoint')">
            <tab-customer ref="tabScheduledContainerStuffing" party-type="LG" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :party-name-list="partyNameList" />
          </el-tab-pane>
          <el-tab-pane name="tabImporterofRecord" :label="getItemTitle('Importer')" :title="$t('SeaExport.Importer')">
            <tab-customer ref="tabImporterofRecord" party-type="IM" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :party-name-list="partyNameList" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import tabCustomer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabCustomer'
import * as ShipmentTypeCode from '@/class/cargo/model/parameters/ShipmentTypeCode'
import * as AmsBLType from '@/class/cargo/model/parameters/AmsBLType'
import { Company } from '@/class/model/mdm/Company'
import StrUtils from '@/utils/StrUtils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
export default {
  name: 'TabISF10',
  components: { CargoAdvanceSelect, tabCustomer },
  props: {
    job: { type: Object, default: null },
    cargoDoc: { type: Object, default: null },
    isfType: { type: Number, default: null },
    isEdit: { type: Boolean, default: false },
    localData: { type: Object, default: () => {} },
    partyNameList: { type: Array, required: true }
  },
  data() {
    return {
      TYPE_NAMES,
      activeTabName: 'tabSellingParty',
      AMSScac: '',
      ShipmentTypeCode: ShipmentTypeCode.Shipment_Type_Code,
      AmsBLType: AmsBLType.Ams_BL_Type,
      isChineseLanguage: false
    }
  },
  watch: {
    activeTabName(newVal, oldVal) {
      // 若新页签不存在或新页签列表无数据时，执行页签的onShow方法
      const tabRef = this.$refs[newVal]
      if (tabRef && (!tabRef.rowData || tabRef.rowData.length === 0)) {
        tabRef.onShow(true)
      }
    },
    cargoDoc(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.tabOnShow()
        }, 1500)
      }
    }
  },
  mounted() {
    this.$refs[this.activeTabName].onShow(true)
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isChineseLanguage = Number(cache.config.get('AntiTerrorismShippingAfrLanguageSwitching')) === 1
  },
  methods: {
    onShow(isRefresh) {
      this.loadDataHandler()
      if (isRefresh) {
        this.$refs[this.activeTabName].onShow(isRefresh)
      }
    },
    async loadDataHandler() {
      if (this.cargoDoc) {
        // load AMSSCAC
        const carrierId = this.job.carrierId
        const company = await Company.getCompanyById(carrierId)
        this.AMSScac = company ? company.scac : ''
      }
    },
    tabOnShow() {
      const tabSellingParty = this.$refs['tabSellingParty']
      if (tabSellingParty) {
        tabSellingParty.onShow()
      }
      const tabBuyingParty = this.$refs['tabBuyingParty']
      if (tabBuyingParty) {
        tabBuyingParty.onShow()
      }
      const tabManufacturer = this.$refs['tabManufacturer']
      if (tabManufacturer) {
        tabManufacturer.onShow()
      }
      const tabConsolidator = this.$refs['tabConsolidator']
      if (tabConsolidator) {
        tabConsolidator.onShow()
      }
      const tabBookingParty = this.$refs['tabBookingParty']
      if (tabBookingParty) {
        tabBookingParty.onShow()
      }
      const tabConsignee = this.$refs['tabConsignee']
      if (tabConsignee) {
        tabConsignee.onShow()
      }
      const tabShipToParty = this.$refs['tabShipToParty']
      if (tabShipToParty) {
        tabShipToParty.onShow()
      }
      const tabScheduledContainerStuffing = this.$refs['tabScheduledContainerStuffing']
      if (tabScheduledContainerStuffing) {
        tabScheduledContainerStuffing.onShow()
      }
      const tabImporterOfRecord = this.$refs['tabImporterofRecord']
      if (tabImporterOfRecord) {
        tabImporterOfRecord.onShow()
      }
    },
    fillModel() {
      if (!this.cargoDoc.isfPassenger) return
      const allList = []
      const tabSellingParty = this.$refs['tabSellingParty']
      if (tabSellingParty) {
        const tabSellingPartyList = tabSellingParty.getTabRowData()
        allList.push(...tabSellingPartyList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 10 && tabIsfData.partyType === 'SE') {
            allList.push(tabIsfData)
          }
        }
      }
      const tabBuyingParty = this.$refs['tabBuyingParty']
      if (tabBuyingParty) {
        const tabBuyingPartyList = tabBuyingParty.getTabRowData()
        allList.push(...tabBuyingPartyList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 10 && tabIsfData.partyType === 'BY') {
            allList.push(tabIsfData)
          }
        }
      }
      const tabManufacturer = this.$refs['tabManufacturer']
      if (tabManufacturer) {
        const tabManufacturerList = tabManufacturer.getTabRowData()
        allList.push(...tabManufacturerList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 10 && tabIsfData.partyType === 'MF') {
            allList.push(tabIsfData)
          }
        }
      }
      const tabConsolidator = this.$refs['tabConsolidator']
      if (tabConsolidator) {
        const tabConsolidatorList = tabConsolidator.getTabRowData()
        allList.push(...tabConsolidatorList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 10 && tabIsfData.partyType === 'CS') {
            allList.push(tabIsfData)
          }
        }
      }
      const tabBookingParty = this.$refs['tabBookingParty']
      if (tabBookingParty) {
        const tabBookingPartyList = tabBookingParty.getTabRowData()
        allList.push(...tabBookingPartyList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 10 && tabIsfData.partyType === 'BKP') {
            allList.push(tabIsfData)
          }
        }
      }
      const tabConsignee = this.$refs['tabConsignee']
      if (tabConsignee) {
        const tabConsigneeList = tabConsignee.getTabRowData()
        allList.push(...tabConsigneeList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 10 && tabIsfData.partyType === 'CN') {
            allList.push(tabIsfData)
          }
        }
      }
      const tabShipToParty = this.$refs['tabShipToParty']
      if (tabShipToParty) {
        const tabShipToPartyList = tabShipToParty.getTabRowData()
        allList.push(...tabShipToPartyList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 10 && tabIsfData.partyType === 'ST') {
            allList.push(tabIsfData)
          }
        }
      }
      const tabScheduledContainerStuffing = this.$refs['tabScheduledContainerStuffing']
      if (tabScheduledContainerStuffing) {
        const tabScheduledContainerStuffingList = tabScheduledContainerStuffing.getTabRowData()
        allList.push(...tabScheduledContainerStuffingList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 10 && tabIsfData.partyType === 'LG') {
            allList.push(tabIsfData)
          }
        }
      }
      const tabImporterOfRecord = this.$refs['tabImporterofRecord']
      if (tabImporterOfRecord) {
        const tabImporterOfRecordList = tabImporterOfRecord.getTabRowData()
        allList.push(...tabImporterOfRecordList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 10 && tabIsfData.partyType === 'IM') {
            allList.push(tabIsfData)
          }
        }
      }
      if (this.cargoDoc.isfPassenger) {
        for (const isf of this.cargoDoc.isfPassenger) {
          if (isf.isfType === 5) {
            allList.push(isf)
          }
          if (isf.isfType === 10 && isf.opType === 'del') {
            allList.push(isf)
          }
        }
      }
      this.cargoDoc.isfPassenger = allList
    },
    portChange(p, portCodeField, portNameField) {
      const form = this.cargoDoc
      form[portCodeField] = p.value
      form[portNameField] = p.englishName
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.afrLabelFunc(targetCode)
      }
      return targetCode
    },
    isDifferent(field) {
      return this.localData.importDifferentField && this.localData.importDifferentField.hasOwnProperty(field) ? 'warning' : ''
    }
  }
}
</script>

<style scoped>

</style>
